let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("e61bl")).then(() => parcelRequire('ieTY5'));